// resources/js/plugins/IdleTimeout.js

export default {
    install(app, options = {}) {
      const { timeout = 300000, store } = options; // default to 5 minutes

      let timer;

      const resetIdleTimer = () => {
        if (timer) {
          clearTimeout(timer);
        }
        timer = setTimeout(() => {
          store.dispatch('logout');
          app.config.globalProperties.$router.push({ name: 'Login' });
        }, timeout);
      };

      window.addEventListener('mousemove', resetIdleTimer);
      window.addEventListener('keypress', resetIdleTimer);

      app.config.globalProperties.$resetIdleTimer = resetIdleTimer;
    }
  };
